// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_bY0","cls2":"ImpactHubModal-cls2_yjU ImpactHubModal-cls1_bY0"};